import {preload} from '@autocut/types/ElectronPreload';
import {createContext, useCallback, useContext, useState} from 'react';

type OutputContext = {
  output: string;
  setOutput: (output: string) => void;
  copyOutput: () => void;
};

export const OutputContext = createContext<OutputContext>({
  output: '',
  setOutput: () => {},
  copyOutput: () => {},
});

export const OutputProvider = ({children}: {children: any}) => {
  const [output, setOutput] = useState('');

  const copyOutput = useCallback(() => {
    preload.electron.setClipboard(output);
  }, [output]);

  return (
    <OutputContext.Provider
      value={{
        output,
        copyOutput,
        setOutput,
      }}
    >
      {children}
    </OutputContext.Provider>
  );
};

export const useOutput = () => useContext(OutputContext);
